"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _EmptyState = _interopRequireDefault(require("./EmptyState.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var EmptyState = function EmptyState(_ref) {
  var children = _ref.children,
      className = _ref.className,
      testId = _ref.testId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_EmptyState.default.component, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _EmptyState.default.emptyStateContent,
    "data-testid": testId
  }, children));
};

EmptyState.defultProps = {
  title: '',
  subtitle: '',
  illustration: undefined,
  children: undefined,
  testId: 'empty-state'
};
EmptyState.propTypes = {
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  illustration: _propTypes.default.node,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  testId: _propTypes.default.string
};

EmptyState.Title = function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _EmptyState.default.emptyStateTitle
  }, children);
};

EmptyState.Title.displayName = 'EmptyState.Title';
EmptyState.Title.propTypes = {
  children: _propTypes.default.node.isRequired
};

EmptyState.Illustration = function (_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_EmptyState.default.emptyStateIllustration, className)
  }, children);
};

EmptyState.Illustration.displayName = 'EmptyState.Illustration';
EmptyState.Illustration.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string
};

EmptyState.Subtitle = function (_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _EmptyState.default.emptyStateSubtitle
  }, children);
};

EmptyState.Subtitle.displayName = 'EmptyState.Subtitle';
EmptyState.Subtitle.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = EmptyState;
exports.default = _default;